export default __webpack_public_path__ + "static/MediaMainBanner-9fb82e03ead65b592b74a4601b91a1ac.webp";